import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PermissionService } from './permission.service';

@Injectable({
    providedIn: 'root'
})
export class ModuleGuardService  {
    constructor(
        public permissionService: PermissionService,
        public router: Router,
	    private messageService: MessageService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {

        const moduleObject: string = route.data.moduleObject as string;
        const moduleName: string = route.data.moduleName as string;

        const userPermissions = this.permissionService.getPemrissionData();
        const modulePermissions = userPermissions.find(obj => obj.objectName == moduleObject);

        const permission = modulePermissions ? (modulePermissions?.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

        if(!permission){
            this.messageService.add({ severity: 'error', summary: 'Error', detail: `You don't have permission to access ${moduleName}` });
            this.router.navigate(["**"]);
        }
        return permission;
    }
}
